var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { apiFetcher } from "@common/fetchers/api-fetcher";
import { ENDPOINTS } from "@common/constants/endpoints";
import useSWRInfinite from "swr/infinite";
import { useState } from "react";
import { debounce } from "throttle-debounce";
import { getSearchParamPageNumber } from "@react-common/middleware/swr/get-initial-size";
import { urlSearchParamsMiddleware } from "@react-common/middleware/swr/url-search-params-middleware";
export var searchRequestOptions = {
    method: "POST",
};
var useSearch = function (_a) {
    var _b;
    var initialSearchParams = _a.initialSearchParams, fallbackData = _a.fallbackData, siteId = _a.siteId, _c = _a.pageSize, pageSize = _c === void 0 ? 12 : _c, initialSearchLocation = _a.initialSearchLocation;
    var initialNodeId = initialSearchParams.get("nodeId");
    var _d = __read(useState((_b = initialSearchParams.get("query")) !== null && _b !== void 0 ? _b : ""), 2), searchedTerm = _d[0], setSearchedTerm = _d[1];
    var _e = __read(useState(initialSearchLocation), 2), searchLocation = _e[0], setSearchLocation = _e[1];
    var _f = __read(useState(initialNodeId ? parseInt(initialNodeId) : 0), 2), nodeId = _f[0], setNodeId = _f[1];
    var handleSearch = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!value || value.length < 1 || value === searchedTerm)
                return [2 /*return*/];
            setSearchedTerm(value);
            return [2 /*return*/];
        });
    }); };
    var debouncedHandleSearch = debounce(200, function (value) {
        return handleSearch(value);
    });
    var getKey = function (pageIndex, previousPageData) {
        var _a;
        if (!searchedTerm || (searchedTerm === null || searchedTerm === void 0 ? void 0 : searchedTerm.length) < 1)
            return null;
        if (previousPageData && !((_a = previousPageData === null || previousPageData === void 0 ? void 0 : previousPageData.collection) === null || _a === void 0 ? void 0 : _a.length))
            return null;
        return [
            ENDPOINTS.search + "?pageNumber=" + (pageIndex + 1) + "&pageSize=" + pageSize + "&query=" + searchedTerm + "&siteId=" + siteId + "&nodeId=" + nodeId,
            searchRequestOptions,
        ];
    };
    var _g = useSWRInfinite(getKey, apiFetcher, __assign({ use: [urlSearchParamsMiddleware], initialSize: getSearchParamPageNumber(), revalidateOnFocus: false, revalidateOnMount: true, dedupingInterval: 10000, refreshInterval: 0 }, (fallbackData && {
        fallbackData: [fallbackData],
    }))), data = _g.data, error = _g.error, isValidating = _g.isValidating, mutate = _g.mutate, size = _g.size, setSize = _g.setSize;
    return {
        searchCollection: data,
        isLastPage: !!(data === null || data === void 0 ? void 0 : data.find(function (x) { return !x.hasNextPage; })),
        handleSearch: debouncedHandleSearch,
        searchedTerm: searchedTerm,
        error: error,
        isValidating: isValidating,
        mutate: mutate,
        size: size,
        setSize: setSize,
        setNodeId: setNodeId,
        nodeId: nodeId,
        searchLocation: searchLocation,
        setSearchLocation: setSearchLocation,
    };
};
export { useSearch };
